import { forwardRef } from 'react';
export var decorateName = (Component, name) => {
  if (name) {
    Component.displayName = name;
  } else {
    Component.displayName = Component.displayName || Component.name;
  }
  return Component;
};
export var wrap = (component, name) => {
  if (name) {
    return decorateName( /*#__PURE__*/forwardRef(component), name);
  } else {
    return /*#__PURE__*/forwardRef(component);
  }
};
export var coerceToNumber = v => {
  if (typeof v === 'number') return v;else {
    var parsed = Number.parseFloat(v);
    if (Number.isNaN(parsed)) {
      throw new Error('expecting an number or stringified number');
    } else return parsed;
  }
};
//# sourceMappingURL=utils.js.map